import React,{ useEffect, useState, useRef} from "react";
import {useParams} from 'react-router-dom';
import { v4 as uuidv4 } from "uuid";
import { MESSAGE_PREVIEW_FOR_CAMPAIGN_LINK, VARIABLE_HELP_TEXT, MIME_HELP_TEXT } from '../../constants/constants';
import { notifyError,notifyErrorInBottom, notifySuccess } from "../../helper";
import { confirmAlert } from "react-confirm-alert"; // Import the library
import DraftEditor from "../DraftEditor";
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import Tabs from "./Tabs";
import FollowUp from "./FollowUp";
import client from "../../api";
import DataLoader from "../DataLoader";
import SendTestMessageModelWindow from "./models/SendTestMessageModelWindow";
import VariableSelectBox from "../VariableSelectBox";

let   initStepsBackup = [];
const ComposeMessageForCampaign = () => {
    
    const api = client();
    const {campaignID} = useParams('');
    const [loading, setLoading] = useState(false);
    const [pageLoader,setPageLoader] = useState(true);
    const [campaignSteps, setCampaignSteps] = useState([]);
    const [campaignPreview,setCampaignPreview] = useState({});
    const [messageMimeType, setMessageMimeType] = useState("text/html");
    const [selectedStepIndex, setSelectedStepIndex] = useState(0);
    const [toggleSendTestModelWindow,setToggleSendTestModelWindow] = useState(false);
    const [errors, setErrors] = useState([]);
    const textareaRef = useRef(null);
    const getNewStep = () => {
        setErrors([...errors,{subject:"",body:"",minimumDelay:""}]);
        const newInstance = {
            subject: "",
            body:'',
            minimum_delay_after_last_send:0,
            new_step_id:uuidv4()
        }
        return newInstance;
    }

    const addFollowUps = () => {
        const all_steps = structuredClone(campaignSteps)
        const new_step = getNewStep()
        // Set default values
        new_step.subject = `Re: ${campaignSteps[0].subject}`
        new_step.minimum_delay_after_last_send = 7
        all_steps.push(new_step)
        setCampaignSteps(all_steps)
    }
   
    const initSteps = (steps) => {
        if(!steps.length){
            const oneStepArr = []
            oneStepArr.push(getNewStep())
            initStepsBackup = structuredClone(oneStepArr)
            setCampaignSteps(oneStepArr)
        }else {
            initStepsBackup = structuredClone(steps)
            setCampaignSteps(steps);
            const errorInstance = steps.map((row,i)=>({subject:"",body:"",minimumDelay:""}));
            setErrors([...errorInstance]);
        }        
    }

    const saveComposedMessages = async () => {
        if(!validateAllFields()){
            const old_steps = []
            const new_steps = []

            campaignSteps.forEach((step, i) => {
                if(typeof step.step_id !== 'undefined'){
                    old_steps.push(step)
                }else if (typeof step.new_step_id !== 'undefined'){
                    new_steps.push(step)
                }
            })
            
            if(!old_steps.length){
                try{
                    setLoading(true);
                    const payload = {
                        campaign_id:campaignID,
                        message_mime_type:messageMimeType,
                        current_tab: "preview",
                        completed_tabs: ["start", "add-recipients", "compose","preview","options"],
                        new_steps:[...new_steps]
                    };
                    
                    const response = await api.post('/v1/campaign/steps/add',payload);
                    if(response.status === 200 || response.status === 201 ){
                        setLoading(false);
                        notifySuccess('Campaign Messages added successfully');
                        initSteps(response.data.data.steps)
                        setTimeout(()=>{
                            window.location.href = MESSAGE_PREVIEW_FOR_CAMPAIGN_LINK.replace(':campaignID',campaignID);
                        },1500);
                    }
                } catch (error) {
                    console.log('error.message',error);
                    setLoading(false);
                    if(error.status === 400) notifyError('Bad Request. Unable to add Campaign Messages.');
                } finally{
                    setLoading(false);
                }
            } else {
                try{
                    setLoading(true);
                   const oldStepPayload = old_steps.map((value,i)=>{
                        value.minimum_delay_after_last_send = parseInt(value.minimum_delay_after_last_send);
                        if(messageMimeType === 'text/plain'){
                            value.body = convertHtmlToPlainText(value.body);
                        }
                        if(messageMimeType === 'text/html'){
                            value.body = plainTextToHTMLParagraphs(value.body);
                        }
                        return value;
                    });

                    const newStepPayload = new_steps.map((value,i)=>{
                        value.minimum_delay_after_last_send = parseInt(value.minimum_delay_after_last_send);
                        if(messageMimeType === 'text/plain'){
                            value.body = convertHtmlToPlainText(value.body);
                        }
                        if(messageMimeType === 'text/html'){
                            value.body = plainTextToHTMLParagraphs(value.body);
                        }
                        return value;
                    });

                    const payload = {
                        campaign_id: campaignID,
                        message_mime_type: messageMimeType,
                        old_steps: [...oldStepPayload],
                        new_steps: [...newStepPayload],
                        // Add currentTab and completedTab fields in request, only if current_tab is "compose" in the campaign
                        ...(campaignPreview.current_tab === "compose" && {
                            current_tab: "preview",
                            completed_tabs: ["start", "add-recipients", "compose", "preview", "options"],
                        }),
                    }
                    
                    const response = await api.post('/v1/campaign/steps/update',payload);
                    
                    if(response.status === 200 || response.status === 201 ){
                        setLoading(false);
                        notifySuccess('Campaign Messages updated successfully');
                        initSteps(response.data.data.steps)
                        setTimeout(()=>{
                            window.location.href = MESSAGE_PREVIEW_FOR_CAMPAIGN_LINK.replace(':campaignID',campaignID);
                        },1500);
                    }
                    
                } catch (error) {
                    console.log('error.message',error);
                    setLoading(false);
                    if(error.status === 400) notifyError('Bad Request. Unable to update Campaign Messages.');
                }
            } 
        } else {
            notifyErrorInBottom('Please fill all the fields');
        }       
    }

    const handleStepChange = (step, key) => {
        return (e) => {
            const all_steps = structuredClone(campaignSteps)
            const initial_subject = all_steps[0].subject
            const updated_steps = all_steps.map((currentStep, i ) => {
                if(typeof step.step_id !== 'undefined') {
                    if (currentStep.step_id === step.step_id){
                        if (key === 'body') {
                            currentStep[key] = (typeof e?.target?.nodeName !== "undefined" && e?.target?.nodeName === 'TEXTAREA' ? e.target.value : e);
                        } else if(key === 'minimum_delay_after_last_send'){
                            currentStep[key] = (e.target.value !== '' ? parseInt(e.target.value) : '')
                        } else {
                            currentStep[key] = e.target.value
                        }
                    }
                }else if (currentStep.new_step_id !== 'undefined') {
                    if (currentStep.new_step_id === step.new_step_id){
                        if (key === 'body') {
                            currentStep[key] = (typeof e?.target?.nodeName !== "undefined" && e?.target?.nodeName === 'TEXTAREA' ? e.target.value : e);
                        } else if(key === 'minimum_delay_after_last_send'){
                            currentStep[key] = (e.target.value !== '' ? parseInt(e.target.value) : '')
                        } else {
                            currentStep[key] = e.target.value
                        }
                    }
                }

                if (i > 0){
                    currentStep['subject'] = `Re: ${initial_subject}`
                }
                return currentStep
            })   
            setCampaignSteps(updated_steps)    
        }
    }
    
    const handleDeleteStep = (step) => {
        return async (e) => {
            // If the delete action is on the old steps already there in the database
            // Then send a request to api
            // @todo Add a loader
            if(typeof step.step_id !== 'undefined'){
                const response = await api.post('/v1/campaign/steps/delete',{
                    campaignID: campaignID,
                    stepID: step.step_id
                });

                if(response.status === 200 || response.status === 201){
                    notifySuccess('Followup step deleted..!!');
                    // @todo this filtering should not be required. The response data should
                    // just get all the steps in the db and it should replace the whole campaign data
                    // like initSteps(steps)
                    const updatedSteps = campaignSteps.filter((currentStep,i)=>{
                        if (typeof currentStep.step_id !== 'undefined') {
                            return (currentStep.step_id !== step.step_id)
                        }else {
                            return true
                        }
                    });
                    setCampaignSteps(updatedSteps);
                }
            }
            // If not then simply delete it from the campaignSteps array
            if(typeof step.new_step_id !== 'undefined'){
                const updatedSteps = campaignSteps.filter((currentStep,i)=>{
                    if (typeof currentStep.new_step_id !== 'undefined') {
                        return (currentStep.new_step_id !== step.new_step_id)
                    }else {
                        return true
                    }
                });
                setCampaignSteps(updatedSteps);
            }
        }
    }

    const cancelEdits = () => {
        // Set old backup as the new value
        window.location.reload();
        //setCampaignSteps(initStepsBackup)
    }

    const handleFieldErrors = (errors) => {
        setErrors([...errors]);
    }

    const handleRemoveError = (index) => {
        return () => {
            const updatedErrors = errors.filter((row,i)=>(index !== i));
            setErrors([...updatedErrors]);
        }        
    }

    const handleCheckbox = (e) => {
        setMessageMimeType(e.target.checked ? "text/plain":"text/html");        
    }

    const validateData = () => {
        campaignSteps.forEach((row,i)=>{
            if(i === 0){
                if(!(row.subject).length){
                    const err = errors.map((r,j)=>{
                        if(i === j){
                            r['subject'] = 'Please enter valid subject';
                        }
                        return r;
                    })
                    setErrors([...err]);
                }
                if((row.body).length <= 1){
                    const err = errors.map((r,j)=>{
                        if(i === j){
                            r['body'] = 'Please enter message body';
                        }
                        return r;
                    })
                    setErrors([...err]);
                }
            } else {
                if(!(row.subject).length){
                    const err = errors.map((r,j)=>{
                        if(i === j){
                            r['subject'] = 'Please enter valid subject';
                        }
                        return r;
                    })
                    setErrors([...err]);
                }
                if((row.body).length <= 1){
                    const err = errors.map((r,j)=>{
                        if(i === j){
                            r['body'] = 'Please enter message body';
                        }
                        return r;
                    })
                    setErrors([...err]);
                }
                if((row.minimum_delay_after_last_send).length && row.minimum_delay_after_last_send === '0'){
                    const err = errors.map((r,j)=>{
                        if(i === j){
                            r['minimumDelay'] = 'The value must be greater than 0';
                        }
                        return r;
                    })
                    setErrors([...err]);
                } else if(!(row.minimum_delay_after_last_send).length && (row.minimum_delay_after_last_send) < 0){
                    const err = errors.map((r,j)=>{
                        if(i === j){
                            r['minimumDelay'] = 'Field can not blank';
                        }
                        return r;
                    })
                    setErrors([...err]);
                }
            }
            return row;
        });
        
        let allErrors = [];
        errors.forEach((row,i)=>{
            if((row.subject).length){
                allErrors.push(true);
            } else if((row.body).length){
                allErrors.push(true);
            } else if((row.minimumDelay).length){
                allErrors.push(true);
            } else{
                allErrors.push(false);
            }
        });
        
        return allErrors;
    }
    const validateAllFields = () => {
       const FountErrors = validateData();
       return FountErrors.includes(true);
    }
    const onBlur = (key, index) => {
        return (e) => {
            if(!(e.target.value).length){
                const updateErrors = errors.filter((err,i)=>{
                    if(index === i){
                        err[key] = "Please enter valid subject";                        
                    }
                    return err;
                })
                setErrors([...updateErrors]);
            }            
        }
    }

    const onFocus = (key, index) => {
        return (e) => {
            const updateErrors = errors.filter((err,i)=>{
                if(index === i){
                    err[key] = "";
                }
                return err;
            })
            setErrors([...updateErrors]);            
        }
    }

    const onEditorBlur = (key,index) => {
        return(e) =>{
            if(((e.target).innerText).length <= 1){
                const updateErrors = errors.filter((err,i)=>{
                    if(index === i){
                        err[key] = "Please enter message body";                        
                    }
                    return err;
                })
                setErrors([...updateErrors]);
            } 
        }
    }
    const onEditorFocus = (key,index) => {
        return(e) =>{
            const updateErrors = errors.filter((err,i)=>{
                if(index === i){
                    err[key] = "";
                }
                return err;
            })
            setErrors([...updateErrors]); 
        }
    }

    const convertHtmlToPlainText = (html) => {
        const element = document.createElement('div');
        element.innerHTML = html;
        return element.innerText || element.textContent;
    }

    const isHtml = (text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
    }

    const plainTextToHTMLParagraphs = (text) => {
        if (isHtml(text)) {
            return text; // Return as is if it's already HTML
        }

        const escaped = text
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      
        const lines = escaped.split("\n");
        return lines.map(line => `<p>${line}</p>`).join("");
    } 

    const openModelWindow = (stepIndex) => {
        setSelectedStepIndex(stepIndex);
        setToggleSendTestModelWindow(!toggleSendTestModelWindow);
    }

    const handleInsertAtCursor = (item) => {
        const textarea = textareaRef.current;
        
       let text = convertHtmlToPlainText(campaignSteps[0].body);
        // Get current cursor position
        const cursorPosition = textarea.selectionStart;
    
        // Insert the item at the cursor position
        const newText = text.slice(0, cursorPosition) + item + text.slice(cursorPosition);
    
        // Update the text and set the cursor position back after inserting
        updateContentWithVariable(newText, 0);
        // After inserting, set the cursor back to where it was
        setTimeout(() => {
          textarea.selectionStart = cursorPosition + item.length;
          textarea.selectionEnd = cursorPosition + item.length;
          textarea.focus();
        }, 0);
      };

      const updateContentWithVariable = (newContent,index) => {
        const tempCampaignSteps = [...campaignSteps];
        tempCampaignSteps.map((row,i)=>{
            if(i === index){
                return row.body = newContent
            } else {
                return row
            }
        });
    }
    useEffect(()=>{
        const getCampaignSteps = async () => {
            try{
                const response = await api.post('/v1/campaign/steps/all',{
                    campaignID:campaignID
                });
                if(response.status === 200 || response.status === 201){
                    const steps = response.data.data.steps;
                    initSteps(steps)
                    setPageLoader(false);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Overview');
                setPageLoader(false);
            }
        }
        if(!campaignSteps.length) getCampaignSteps();
    },[]);

    useEffect(()=>{
        const getCampaignPreview = async () => {
            try{
                const response = await api.post('/v1/campaign/preview',{ campaign_id:campaignID });
                if(response.status === 200 ||response.status === 201 ){
                    setCampaignPreview(response.data.campaignPreview);
                    const mimeType = response.data.campaignPreview.message_mime_type;
                    setMessageMimeType((mimeType === '' || mimeType === null) ? 'text/html' : mimeType);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Overview');
            }
        }
        getCampaignPreview();
    },[]);

    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="campaign-create-steps">
                <div className="top-section">
                    <h1>Add Campaign </h1>                
                </div>
                {!pageLoader && campaignSteps.length > 0 ? <div className="steps-wrap">
                    <Tabs currentTab="compose" completedTabs={campaignPreview.completed_tab || []} />
                    
                    <div className="compose-step">
                        <h3 className="h3-title">Compose the emails in this campaign</h3>
                        
                        <div className="compose-email">
                        <div className="field-wrap single-row">
                                <label className="label-xs">Send in plain text:</label>
                                <div className="checkbox-wrapper-22">
                                    <label className="switch" htmlFor="mime-checkbox">
                                        <input
                                            id="mime-checkbox" 
                                            type="checkbox"
                                            value={messageMimeType}
                                            checked={messageMimeType === 'text/plain'}  
                                            onChange={(e)=>handleCheckbox(e)}
                                            />
                                        <div className="slider round"></div>
                                    </label>
                                </div>
                                <div className="mime-helpbox">
                                    <span><i className='bx bx-error'></i></span>
                                    <div className="helpbox-details">
                                        <p>{MIME_HELP_TEXT}</p>
                                    </div>
                                </div>    
                            </div>
                            <div className="test-link">
                                <button 
                                    type="button" 
                                    onClick={()=>{openModelWindow(0)}}
                                    ><i className='bx bx-paper-plane'></i> Send Test</button>
                            </div>
                            <div className="field-wrap">
                                <label className="label-xs">Subject:</label>
                                <input
                                    name="subject" 
                                    type="text" 
                                    placeholder="Subject"
                                    value={campaignSteps[0]?.subject}
                                    onChange={handleStepChange(campaignSteps[0],'subject')}
                                    onBlur={onBlur('subject', 0)}
                                    onFocus={onFocus('subject', 0)}
                                    ></input>
                            {errors.length ? <span className="validation-error">{errors[0].subject}</span>:''}        
                            </div>
                            
                            <div className="compose-message">
                                {messageMimeType === 'text/html' ? ((campaignSteps.length > 0) ? <DraftEditor
                                    emailVariables={true}
                                    className={'compose-editor'}
                                    onContentChange={handleStepChange(campaignSteps[0],'body')}
                                    defaultContent={campaignSteps[0].body}
                                    onBlur={onEditorBlur('body', 0)}
                                    onFocus={onEditorFocus('body', 0)}
                                /> :<DraftEditor
                                        emailVariables={true}
                                        className={'compose-editor'}
                                        onContentChange={handleStepChange(campaignSteps[0],'body')}
                                        defaultContent={''}
                                        onBlur={onEditorBlur('body', 0)}
                                        onFocus={onEditorFocus('body', 0)}
                                    />):<>
                                    <div className="btn-group">
                                        <VariableSelectBox 
                                        handleInsertAtCursor = {handleInsertAtCursor}
                                        />
                                        <div className="variable-helpbox">
                                            <span><i className='bx bx-question-mark'></i></span>
                                            <div className="helpbox-details">
                                                <p>{VARIABLE_HELP_TEXT}</p>
                                            </div>
                                        </div>
                                    </div>
                                        <textarea 
                                            ref = {textareaRef}
                                            onInput = {handleStepChange(campaignSteps[0],'body')}  
                                            value={convertHtmlToPlainText(campaignSteps[0].body)}
                                            onBlur={onBlur('body', 0)}
                                            onFocus={onFocus('body', 0)}
                                            />
                                    </> }
                            {errors.length ? <span className="validation-error">{errors[0].body}</span>:''}
                            </div>
                        
                            {campaignSteps.length && <div className="follow-ups">
                                <h2>Follow-ups</h2>
                                <p>Follow-up are stopped when a recipient becomes a lead.</p>
                                <div className="follow-up-fields-wrap">
                                    
                                    {campaignSteps.map((step,i)=>(
                                        i !== 0 && <FollowUp
                                            index={ i } 
                                            errors={ errors } 
                                            key={ i } 
                                            step={ step } 
                                            handleStepChange={ handleStepChange } 
                                            handleDeleteStep={ handleDeleteStep }
                                            handleRemoveError={ handleRemoveError }
                                            handleFieldErrors={ handleFieldErrors }
                                            messageMimeType = { messageMimeType }
                                            setToggleSendTestModelWindow = { setToggleSendTestModelWindow }
                                            toggleSendTestModelWindow = { toggleSendTestModelWindow }
                                            setSelectedStepIndex = { setSelectedStepIndex }
                                            />
                                    )) }
                                </div>
                            </div>}

                            <div className="field-wrap">
                                <span className="follow-btn" onClick={addFollowUps}>Add Follow-up</span>
                            </div>
           
                            <div className="btn-wraps">
                                <button className="cancel-btn" onClick={(e) => {
                                     confirmAlert({
                                        title: "Revert Edits...!",
                                        message: "Are you sure you want to cancel the Edits for this Campaign?",
                                        buttons: [
                                            { label: "Revert", onClick: () => {cancelEdits()} },
                                            { label: "Cancel", onClick: () => {console.log('Delete action canceled..!')}}
                                        ]
                                    })
                                    }}>Cancel Edits</button>
                                <button 
                                    className={loading ? 'primary-btn button--loading' :'primary-btn'} 
                                    disabled={loading}
                                    onClick={()=>{saveComposedMessages()}}><span className="button--text">Next</span></button>
                            </div>           
                        </div>
                    </div>                    
                </div>:<DataLoader/>}
            </div>            
        </div>
        {toggleSendTestModelWindow && <SendTestMessageModelWindow 
            setToggleSendTestModelWindow = {setToggleSendTestModelWindow}
            toggleSendTestModelWindow = { toggleSendTestModelWindow }
            campaignID = { campaignID }
            messageMimeType = { messageMimeType }
            selectedStepIndex = { selectedStepIndex }
            steps = { campaignSteps }
            assignedInfo = {campaignPreview?.assigned_to_user }
        />}
        <Footer/>
    </>);
}
export default ComposeMessageForCampaign;